<template>
  <div ref="control" :class="['control', { error: error && error.length }, { success: valid }]">
    <div class="control-wrap">
      <input
        v-model="val"
        :value="true"
        @input="input"
        @blur="blur"
        ref="input"
        :name="name"
        :id="id"
        autocomplete="off"
        :type="type ? type : 'text'"
        :class="['control-input', { 'has-icon': icon }]"
        :placeholder="label"
        :v-validate="validate"
        :disabled="disabled"
      />
      <font-awesome-icon class="control-icon control-icon--left" v-if="icon" :icon="`${icon}`" />
    </div>

    <p class="control-error" v-if="error && error.length">{{ error[0] }}</p>
  </div>
</template>

<script>
export default {
  name: 'FormControlInput',
  mounted() {
    this.$refs.input.value = this.value;
    this.val = this.value;
  },
  data() {
    return {
      states: {},
      val: null
    };
  },
  $_veeValidate: {
    value() {
      return this.val;
    },
    name() {
      return this.name;
    }
  },
  watch: {
    value(newVal) {
      this.$refs.input.value = newVal;
      this.val = newVal;

      const field = this.$parent.$validator.fields.find({ name: this.name });
      if (field) {
        field.setFlags({ dirty: true });
        this.$parent.$validator.validate(this.name);
      }
    }
  },
  props: [
    'type',
    'label',
    'id',
    'error',
    'icon',
    'valid',
    'name',
    'value',
    'pattern',
    'validate',
    'disabled'
  ],
  methods: {
    input() {
      this.$emit('input', this.$refs.input.value);
    },
    blur() {
      this.$emit('blur', this.$refs.input.value);
    }
  }
};
</script>

<style lang="scss">
.control {
  width: 100%;
  display: flex;
  flex-direction: column;

  &.error {
    .control-input,
    .control-checkbox,
    .control-radio {
      border-color: var(--color-assertive);
      background-color: rgba(var(--color-assertive-rgb), 0.05);

      &:focus {
        box-shadow: 0 0 0 3px rgba(var(--color-assertive-rgb), 0.2);
      }
    }

    .control-icon {
      color: var(--color-assertive);
    }
  }

  &.success {
    .control-input {
      border-color: var(--color-balanced);
      background-color: rgba(var(--color-balanced-rgb), 0.05);
    }

    .control-error {
      display: none;
    }
  }
}

.control-wrap {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
}

.control-error {
  margin: 8px 0;
  font-size: 14px;
  color: var(--color-assertive);
}

.control-label {
  cursor: pointer;
  user-select: none;

  a {
    position: relative;
    color: var(--color-balanced);
    text-decoration: underline;
    margin-left: 8px;
  }
}

.control-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 16px;
  color: var(--color-balanced);

  &--left {
    left: 16px;
  }

  &--right {
    right: 24px;
  }
}

.control-input {
  width: 100%;
  padding: 16px;
  border-radius: 4px;
  border: 2px solid var(--color-gray-light);
  transition: var(--transition);
  color: #000;

  &.disabled,
  &[disabled] {
    border-color: var(--color-gray-light);
    background-color: var(--color-gray-white);
    opacity: 0.5;
    pointer-events: none;

    &:focus {
      border-color: var(--color-gray-light);
      box-shadow: none;
    }
  }

  &.has-icon {
    padding-left: 40px;
  }

  &:focus {
    border-color: var(--color-balanced);
    box-shadow: 0 0 0 3px rgba(var(--color-balanced-rgb), 0.2);
  }
}
</style>
